export enum DefectType {
  NONE = -1,
  DEFAULT = 0,
  PRE_REGISTRATION = 1,
  INSPECTION = 2,
}
